import { useCallback } from 'react';
export const useCartActions = ({
    cuttentOptionByClick,
    setCuttentOptionByClick,
    setOptions,
    setBaskets,
  }) => {

    const removeFromCart = useCallback(() =>{
        if(!cuttentOptionByClick || !cuttentOptionByClick?.parrentId) return;
        
        setOptions((prevOptions) => [...prevOptions, {...cuttentOptionByClick, parrentId: null}])

        setBaskets((prevBaskets) => {
            return prevBaskets.map((basket) => {
            if(basket.id == cuttentOptionByClick.parrentId){
                return {
                ...basket,
                options: basket.options.filter((option) => option.id !== cuttentOptionByClick.id)
                }
            }
            return basket;
            })
        })
        setCuttentOptionByClick(null)
    }, [cuttentOptionByClick])
    
    const addFromCart = useCallback((cardId) => {
        if(cardId === cuttentOptionByClick?.parrentId || !cuttentOptionByClick) return;
        
        if(!cuttentOptionByClick.parrentId){
        
            setOptions((prevOptions) => prevOptions.filter((el) => el.id !== cuttentOptionByClick.id));
        
            setBaskets((prevBaskets) => {
                return prevBaskets.map((basket) => {
                    if(basket.id == cardId){
                    return {
                        ...basket,
                        options: [...basket.options, {...cuttentOptionByClick, parrentId: cardId}]
                    }
                    }
                    return basket;
                })
            })
            
        }
        if(cuttentOptionByClick.parrentId){
            setBaskets((prevBaskets) => {
            return prevBaskets.map((elem) => {
                if(elem.id == cardId){
                    return {
                        ...elem,
                        options: [...elem.options, {...cuttentOptionByClick, parrentId: cardId}]
                    }
                }
                if(elem.id == cuttentOptionByClick.parrentId){
                    return {
                        ...elem,
                        options: elem.options.filter((option) => option.id !== cuttentOptionByClick.id)
                    }
                }
                return elem;
            })
            })
        }
        setCuttentOptionByClick(null)
    }, [cuttentOptionByClick])

    return { removeFromCart, addFromCart };
}
